import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { PartnerAuthProvider } from "@/hooks/usePartnerAuth";
import { PartnerLayout } from "@/components/partner/PartnerLayout";
import { PortalErrorBoundary } from '@/components/PortalErrorBoundary';
export const Route = createFileRoute("/partner")({
  component: PartnerRoute,
});
function PartnerRoute() {
  const isNotFound = useRouterState({ select: state => state.matches.some(match => match.routeId === '/partner/$' && match.status === 'notFound') });
  // A genuine missing URL renders only the unprivileged fallback, never a workspace.
  if (isNotFound) return <PortalErrorBoundary />;
  return (
    <PartnerAuthProvider>
      <PartnerLayout />
    </PartnerAuthProvider>
  );
}
